module.exports = __webpack_public_path__ + "img/pic_home_empty@2x.978a2388.png";